import { Row } from "PFComponents/table/table.types";

import { ChildrenTableConfig, NestedTableData } from "../nested_table";
import { TableData, TableProps } from "../table";
import { OnRowClickFn } from "../table.types";
import { NestedTableRow } from "./nested_table_row";

type TableBodyProps<
  CHILDREN_TABLE_DATA extends TableData,
  TABLE_DATA extends NestedTableData<CHILDREN_TABLE_DATA>
> = {
  rows: Row<TABLE_DATA>[];
  onRowClick?: OnRowClickFn<TABLE_DATA>;
  compact?: boolean;
  noHover?: boolean;
  lastRowRef: React.RefObject<HTMLTableRowElement | null> | undefined;
  childrenTableConfig: ChildrenTableConfig<CHILDREN_TABLE_DATA>;
} & Pick<TableProps<TABLE_DATA>, "getRowId">;

export const NestedTableBody = <
  CHILDREN_TABLE_DATA extends TableData,
  TABLE_DATA extends NestedTableData<CHILDREN_TABLE_DATA>
>({
  rows,
  onRowClick,
  compact,
  noHover,
  lastRowRef,
  childrenTableConfig,
  getRowId
}: TableBodyProps<CHILDREN_TABLE_DATA, TABLE_DATA>) => (
  <tbody>
    {rows.map((row, index) => (
      <NestedTableRow<CHILDREN_TABLE_DATA, TABLE_DATA>
        key={row.id}
        row={row}
        onRowClick={onRowClick}
        compact={compact}
        noHover={noHover}
        lastRowRef={rows.length - 1 === index ? lastRowRef : undefined}
        childrenTableConfig={childrenTableConfig}
        getRowId={getRowId}
      />
    ))}
  </tbody>
);
